import React from 'react';
import moment from 'moment';
import { TableRow, TableCell, Tooltip } from '@material-ui/core';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { claimsStatusList, displayDateFormat } from '../../../constants';
import appConfig from '../../../config';

const ClaimRow = ({ item,params }) => {
  let assetTypeNames = {
    1: 'airframe',
    2: 'engines',
    3: 'apu',
    4: 'landing-gears',
  }
  const redirectUrl = (assetNumber) => { window.open(`${appConfig.domain.maintenance}${params?.type}/${params?.aircraft_slug}/maintenance/${assetNumber && assetTypeNames[assetNumber]}`, '_blank')
  }
  const formatted = (number) => number.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
  const prsvTotal =item?.prsv_amount_paid && Object?.keys(item?.prsv_amount_paid)?.length>0&&  Object.values(item?.prsv_amount_paid)?.reduce((sum, value) => sum + value, 0);
  const updatedAmount = item?.llp_amount_paid ? item?.llp_amount_paid : prsvTotal ? prsvTotal : item?.amount_paid ? item?.amount_paid:0
      const prsvClaimTotal =item?.prsv_claim_amount && Object?.keys(item?.prsv_claim_amount)?.length>0&&  Object.values(item?.prsv_claim_amount)?.reduce((sum, value) => sum + value, 0);
      const updatedClaimAmount = item?.llp_claim_amount ? item?.llp_claim_amount : prsvClaimTotal ? prsvClaimTotal : item?.claim_amount ? item?.claim_amount:0
  return (
    <TableRow style={{  cursor: 'pointer' }} hover tabIndex={-1}>
      <TableCell onClick={() => redirectUrl(item?.major_assemblies?.asset_type_number)} style={{ width: "270px" }}>{item?.major_assemblies?.unique_name ? item?.major_assemblies?.unique_name : '--'}</TableCell>
      <TableCell onClick={() => redirectUrl(item?.major_assemblies?.asset_type_number)} style={{ width: "270px" }}>
        {item?.maintenance_check?.description ?
          item?.maintenance_check?.description :
          item?.shop_visit?.name ?
            item?.shop_visit?.name : "--"}</TableCell>
      <TableCell onClick={() => redirectUrl(item?.major_assemblies?.asset_type_number)} style={{ width: "200px" }} >{item?.submission_date ? moment(item?.submission_date).format(displayDateFormat) : '--'}</TableCell>
      <TableCell style={{ width: "245px", cursor: 'pointer' }} onClick={() => redirectUrl(item?.major_assemblies?.asset_type_number)}>
        {item?.shop_visit?.cost? 
          <div >
            {`${item?.currency ? item?.currency + formatted(item?.shop_visit?.cost) :"US$"+ formatted(item?.shop_visit?.cost)}`}
          </div>
          :
          'US$0.00'
        }
      </TableCell>
      
      
        <TableCell onClick={() => redirectUrl(item?.major_assemblies?.asset_type_number)} > <span style={{ display: "block", width: '132px' }}
              className={item.status.value && item?.payout_status?.value && claimsStatusList[item?.payout_status?.value === 4 ||item?.payout_status?.value === 5 || item?.payout_status?.value === 6 ? item?.payout_status?.value : item.status.value  ] + ' invoice-status'}
            >{item?.payout_status?.value === 4 ||item?.payout_status?.value === 5 || item?.payout_status?.value === 6 ?item?.payout_status?.label :   item?.status?.label ? item?.status?.label : '-- '}
            </span></TableCell>

            
                <TableCell style={{ width: "245px", cursor: 'pointer' }} onClick={() => redirectUrl(item?.major_assemblies?.asset_type_number)}>
                    {item?.claim_amount || item?.llp_claim_amount || item?.prsv_claim_amount ?
                      <div >
                        {`${item?.currency ? item?.currency + formatted(updatedClaimAmount) : "US$" + formatted(updatedClaimAmount)}`}
                      </div>
                      :
                      'US$0.00'
                    }
                  </TableCell>
      <TableCell style={{ width: "245px", cursor: 'pointer' }} onClick={() => redirectUrl(item?.major_assemblies?.asset_type_number)}>
        {item?.amount_paid || item?.llp_amount_paid || item?.prsv_amount_paid ? 
          <div >
            {`${item?.currency ? item?.currency + formatted(updatedAmount) :"US$"+ formatted(updatedAmount)}`}
          </div>
          :
          'US$0.00'
        }
      </TableCell>
      <TableCell onClick={() => redirectUrl(item?.major_assemblies?.asset_type_number)} >{item?.approved_by ? item?.approved_by?.name : '--'}</TableCell>
      <TableCell align='left'>
        <Tooltip title='View'>
          <VisibilityIcon color='primary' fontSize='small' style={{ cursor: 'pointer' }} onClick={() => redirectUrl(item?.major_assemblies?.asset_type_number)} />
        </Tooltip>
      </TableCell>
    </TableRow>
  )
}
export default ClaimRow;
